export default {
    noEvent: 'Aucun événement trouvé',
    noEventDesc: 'Veuillez vous reconnecter.',
    noLocation: 'Lieu non défini',
    guestList: 'Liste des invités',
    guestListDesc: 'Voir qui participe à l\'événement.',
    tasks: 'Tâches',
    tasksDesc: 'Voir le planning et les tâches à faire.',
    budget: 'Budget',
    budgetDesc: 'Consulter le budget prévisionnel.',
    welcomeTitle: 'Bienvenue sur votre espace invité',
    welcomeDesc: 'Ici vous pouvez consulter les informations de l\'événement et voir la liste des invités. D\'autres fonctionnalités seront bientôt disponibles !'
};
